<section class="flex flex-col w-full max-w-5xl mx-auto px-2 sm:px-3 gap-4 min-w-0 overflow-x-hidden">
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
    <div class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-bold text-gray-800">Veille juridique</h1>
      <p class="text-sm text-gray-600 mt-1">Annonces pour le SIREN de cette entreprise.</p>
    </div>
    <div class="flex flex-col xs:flex-row sm:flex-row flex-wrap gap-2 w-full sm:w-auto">
      <button type="button" (click)="markAllRead()"
              class="px-3 py-2.5 sm:py-2 text-sm border border-gray-200 rounded-md hover:bg-gray-50 cursor-pointer w-full sm:w-auto">
        Tout marquer lu
      </button>
      <button type="button" (click)="sync()" [disabled]="syncing()"
              class="inline-flex items-center justify-center gap-2 px-3 py-2.5 sm:py-2 text-sm bg-secondary text-white rounded-md hover:bg-secondary-hover disabled:opacity-60 cursor-pointer w-full sm:w-auto">
        <lucide-icon [name]="RefreshCw" size="16" [class.animate-spin]="syncing()"></lucide-icon>
        @if (syncing()) { Synchronisation... } @else { Synchroniser }
      </button>
    </div>
  </div>

  <div class="space-y-2">
    @for (a of alerts(); track a.id) {
      <button type="button" (click)="markRead(a)"
              class="w-full text-left bg-white rounded-lg border p-4 shadow-sm hover:border-secondary/25 transition-colors cursor-pointer"
              [class.border-secondary/40]="!a.read"
              [class.bg-secondary/10/40]="!a.read">
        <div class="flex items-start gap-3">
          <lucide-icon [name]="FileText" size="18" class="text-gray-500 shrink-0 mt-0.5"></lucide-icon>
          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap items-center gap-2 text-xs text-gray-500 mb-1">
              <span>{{ a.dateParution | date: 'dd/MM/yyyy' }}</span>
              @if (a.familleAvis) {
                <span class="px-1.5 py-0.5 rounded bg-gray-100 text-gray-700">{{ a.familleAvis }}</span>
              }
              @if (!a.read) {
                <span class="text-secondary font-medium">Nouveau</span>
              }
            </div>
            <p class="text-sm font-medium text-gray-800">{{ a.description }}</p>
            @if (a.ville) {
              <p class="text-xs text-gray-500 mt-1">{{ a.ville }}</p>
            }
          </div>
        </div>
      </button>
    } @empty {
      <p class="text-sm text-gray-500 py-8 text-center">Aucune annonce. Lancez une synchronisation.</p>
    }
  </div>
</section>
